module.exports = __webpack_public_path__ + "img/img17.00111626.svg";